import { render, staticRenderFns } from "./HCPDetails.vue?vue&type=template&id=64a29ac6"
import script from "./HCPDetails.vue?vue&type=script&lang=js"
export * from "./HCPDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports